export default {
  mealsWireToInt,
  mealsIntToWire,
};

function mealsWireToInt (wireMeals) {
  if (!wireMeals) return [];
  let intMeals = [];
  if (wireMeals.length) {
    for (let i = 0; i < wireMeals.length; i++) {
      if (!wireMeals[ i ]._attributes) return [];
      intMeals.push(mealWireToInt(wireMeals[ i ]));
    }
  } else {
    if (!wireMeals._attributes) return [];
    intMeals.push(mealWireToInt(wireMeals));
  }

  return intMeals;
}

function mealWireToInt (wireMeal) {
  const { contact_objectid, label } = wireMeal._attributes;
  const { notes, menuItem } = wireMeal;
  return {
    id: contact_objectid,
    fullName: label,
    notes: notes ? notes._cdata : '',
    meals: selectedMealsWireToInt(menuItem),
  };
}

function selectedMealsWireToInt (wireMeals) {
  if (!wireMeals) return [];
  let intMeals = [];
  if (!wireMeals.length) {
    wireMeals = wireMeals ? wireMeals._attributes : wireMeals;
    intMeals.push(selectedMealWireToInt(wireMeals));
  } else {
    for (let i = 0; i < wireMeals.length; i++) {
      let wireMeal = wireMeals[ i ]._attributes || wireMeals[ i ];
      intMeals.push(selectedMealWireToInt(wireMeal));
    }
  }
  return intMeals;
}

function selectedMealWireToInt (wireMeal) {
  const { menuitemid, selectedOptions } = wireMeal;
  return {
    id: menuitemid,
    description: selectedOptions,
  };
}

function mealsIntToWire (intMeals) {
  let wireMeals = [];
  for (let i = 0; i < intMeals.length; i++) {
    wireMeals.push(mealIntToWire(intMeals[ i ]));
  }
  return wireMeals;
}

function mealIntToWire (intMeal) {
  const { id, fullName, notes, meals } = intMeal;
  return {
    contact_objectid: id,
    label: fullName,
    notes: notes || '',
    menuItem: selectedMealsIntToWire(meals),
  };
}

function selectedMealsIntToWire (intMeals) {
  if (!intMeals || !intMeals.length) return [];
  let wireMeals = [];
  for (let i = 0; i < intMeals.length; i++) {
    wireMeals.push(selectedMealIntToWire(intMeals[ i ]));
  }
  return wireMeals;
}

function selectedMealIntToWire (intMeals) {
  const { id, description } = intMeals;
  return {
    menuitemid: id,
    selectedOptions: description,
  };
}



// WEBPACK FOOTER //
// ./src/converter/SelectedMealsConverter.js